export const FETCH_ALL_DELIVERY_NOTES = "FETCH_ALL_DELIVERY_NOTES";
export const FETCH_ALL_DELIVERY_NOTES_SUCCESS = "FETCH_ALL_DELIVERY_NOTES_SUCCESS";
export const FETCH_ALL_DELIVERY_NOTES_FAILURE = "FETCH_ALL_DELIVERY_NOTES_FAILURE";

export const FETCH_DELIVERY_NOTE_DETAILS = "FETCH_DELIVERY_NOTE_DETAILS";
export const FETCH_DELIVERY_NOTE_DETAILS_SUCCESS = "FETCH_DELIVERY_NOTE_DETAILS_SUCCESS";
export const FETCH_DELIVERY_NOTE_DETAILS_FAILURE = "FETCH_DELIVERY_NOTE_DETAILS_FAILURE";

export const CREATE_DELIVERY_NOTE = "CREATE_DELIVERY_NOTE";
export const CREATE_DELIVERY_NOTE_SUCCESS = "CREATE_DELIVERY_NOTE_SUCCESS";
export const CREATE_DELIVERY_NOTE_FAILURE = "CREATE_DELIVERY_NOTE_FAILURE";

export const UPDATE_DELIVERY_NOTE = "UPDATE_DELIVERY_NOTE";
export const UPDATE_DELIVERY_NOTE_SUCCESS = "UPDATE_DELIVERY_NOTE_SUCCESS";
export const UPDATE_DELIVERY_NOTE_FAILURE = "UPDATE_DELIVERY_NOTE_FAILURE";

export const DELETE_DELIVERY_NOTE = "DELETE_DELIVERY_NOTE";
export const DELETE_DELIVERY_NOTE_SUCCESS = "DELETE_DELIVERY_NOTE_SUCCESS";
export const DELETE_DELIVERY_NOTE_FAILURE = "DELETE_DELIVERY_NOTE_FAILURE";

export const SET_DELIVERY_NOTE_IS_EDIT = "SET_DELIVERY_NOTE_IS_EDIT";
